<template>
  <tile-grid>
    <service-group-tile
      v-for="group in getServiceGroupsByPlace(getPlace)"
      :key="`${group.id}-${getPlace.id}`"
      :group="group"
      :place="getPlace"
    />
  </tile-grid>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import TileGrid from '@/components/utils/TileGrid';
import ServiceGroupTile from '@/components/service-groups/ServiceGroupTile';

export default {
  name: 'ServiceGroups',
  mixins: [
    BreadcrumbsManager,
  ],
  props: {
    placeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      active: [],
    };
  },
  computed: {
    ...mapGetters([
      'getPlaceById',
      'getPlaceName',
    ]),
    ...mapGetters('service-group', [
      'getServiceGroupsByPlace',
    ]),
    getPlace() {
      return this.getPlaceById(this.placeId);
    },
    breadcrumbs() {
      return [
        {
          disabled: true,
          text: this.getPlaceName(this.placeId),
        },
        {
          text: this.$t('service-groups'),
        },
      ];
    },
  },
  methods: {
    ...mapActions([
    ]),
  },
  components: {
    ServiceGroupTile,
    TileGrid,
  },
};
</script>

<style scoped>
</style>
